import { Chip } from '@peritasai/ui-components';
import { useTranslation } from 'react-i18next';

type CartStatusPillProps = {
  isAtRisk: boolean;
};

const atRiskSx = {
  height: '24px',
  padding: '0px',
  backgroundColor: '#e53284',
  color: '#fff',
  fontSize: '11px',
  fontWeight: 700,
  borderRadius: '20px',
  textTransform: 'none' as const,
  letterSpacing: 'normal',
  '&:hover': { backgroundColor: '#e53284' },
  '& .MuiChip-label': { padding: '5px 12px' },
};

const onTrackSx = {
  height: '24px',
  padding: '0px',
  backgroundColor: '#901de4',
  color: '#fff',
  fontSize: '11px',
  fontWeight: 700,
  borderRadius: '20px',
  textTransform: 'none' as const,
  letterSpacing: 'normal',
  '&:hover': { backgroundColor: '#901de4' },
  '& .MuiChip-label': { padding: '5px 12px' },
};

export const CartStatusPill = ({ isAtRisk }: CartStatusPillProps) => {
  const { t } = useTranslation(['periverse']);
  return (
    <Chip
      size="small"
      sx={isAtRisk ? atRiskSx : onTrackSx}
      label={
        isAtRisk
          ? t('pages.caseCartAssembly.atRiskLabel')
          : t('pages.caseCartAssembly.onTrackLabel')
      }
      data-testid="cart-status-pill"
    />
  );
};
